export const listStyles = {
  listItem: {
    alignItems: "left",
    display: "flex",
    flex: "1"
  },
  listLinkStyle: {
    ":hover": {
      color: "#3a56ff"
    },
    color: "#3b5998",
    cursor: "pointer",
    fontSize: "12px",
    paddingRight: "5px",
    textDecoration: "underline"
  },
  row: {
    "@media (min-width: 1024px)": {
      alignItems: "left",
      padding: "10px 20px"
    },
    alignItems: "center",
    backgroundColor: "#fff",
    borderColor: "#ddd",
    borderStyle: "solid",
    borderTop: "none",
    borderWidth: "1px",
    display: "flex",
    fontSize: "13px",
    height: "auto",
    minHeight: "25px",
    padding: "5px"
  },
  rowHeader: {
    "@media (min-width: 1024px)": {
      padding: "10px 20px"
    },
    alignItems: "left",
    backgroundColor: "#efefef",
    borderBottom: "1px solid #eee",
    borderLeft: "1px solid #ddd",
    borderRight: "1px solid #ddd",
    borderTop: "none",
    display: "flex",
    fontSize: "13px",
    fontWeight: "bold",
    height: "auto",
    padding: "5px"
  },
  subItem: {
    display: "flex",
    flexDirection: "column",
    width: "100%"
  },
  subItemInfo: {
    "@media (min-width: 600px)": {
      display: "inline"
    },
    color: "#999",
    display: "none",
    fontSize: "13px"
  }
};
